import { Controller } from "@hotwired/stimulus";
import { translate } from "../app/helpers/classes/translation";

// "Läs mer" on a step3 addon card expands its full description inline,
// directly below the short summary -- an accordion, not a popup. Matches
// the mobile Figma spec exactly, and (per this session's mobile-unification
// plan) desktop and mobile now share this one behavior instead of desktop
// using a modal. The description body is still fetched lazily (only once,
// cached after) rather than rendered upfront for every addon on the page,
// same performance tradeoff the old ajax-modal made.
export default class extends Controller {
  static targets = ["label", "chevron", "panel"];
  static values = { url: String };

  async toggle(event) {
    event.preventDefault();
    const opening = this.panelTarget.classList.contains("hidden");

    if (opening && this.panelTarget.dataset.loaded !== "true") {
      this.panelTarget.innerHTML = '<div class="py-2 text-sm text-gray-500">Laddar...</div>';
      try {
        const response = await fetch(this.urlValue);
        this.panelTarget.innerHTML = await response.text();
        this.panelTarget.dataset.loaded = "true";
      } catch (e) {
        this.panelTarget.innerHTML = `<div class="py-2 text-sm text-gray-500">${translate("Något gick fel.")}</div>`;
      }
    }

    this.panelTarget.classList.toggle("hidden");
    if (this.hasChevronTarget) this.chevronTarget.classList.toggle("rotate-180", opening);
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = opening
        ? this.labelTarget.dataset.openLabel
        : this.labelTarget.dataset.closedLabel;
    }
  }
}
